<template>
	<el-dialog :title="title" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
		<el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
			<el-form-item label="显示名称" prop="showName">
				<el-input v-model="form.showName" maxlength="30" placeholder="请输入显示名称"></el-input>
			</el-form-item>
			<el-form-item label="排序值" prop="showSort">
				<el-input v-model="form.showSort" maxlength="10" placeholder="请输入排序值"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { courseSkillShowAdd, courseSkillShowUpdate } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			submitLoading: false,
			title: "新增显示名",
			form: {
				skillId: "",
				showName: "",
				showSort: "",
			},
			rules: {
				showName: [{ required: true, message: "请输入显示名称", trigger: "blur" }],
				showSort: [
					{ required: true, message: "请输入排序值", trigger: "blur" },
					{ pattern: /^[1-9]\d*$/, message: "排序值必须是正整数", trigger: "blur" },
				],
			},
		};
	},
	methods: {
		// 初始化弹窗
		init(skillId, dt) {
			this.dialogVisible = true;
			this.submitLoading = false;
			// 等待DOM更新后重置表单
			this.$nextTick(() => {
				this.$refs.form.resetFields();
				this.title = dt ? "编辑显示名" : "新增显示名";
				this.form = dt ? { ...dt, skillId } : { skillId, showName: "", showSort: "" };
			});
		},
		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},
		// 提交表单
		handleSubmit: debounce(function () {
			this.$refs.form.validate((valid) => {
				if (!valid) return;
				if (this.submitLoading) return;
				this.handleClose();
				const api = this.form.id ? courseSkillShowUpdate : courseSkillShowAdd;
				const msg = this.form.id ? "编辑成功" : "新增成功";
				api(this.form).then((res) => {
					this.submitLoading = false;
					if (res.code != "0") return this.$message.error(res.msg);
					this.$message.success(msg);

					this.$emit("refresh");
				});
			});
		}, 300),
	},
};
</script>

<style scoped></style>
